import React from 'react';
import { RotatingLines } from 'react-loader-spinner';


const LoadingOverlay = () => {
    return (
        <>
                <div className='loading-overlay'>
                    <RotatingLines
                        strokeColor="#7ea9f7"
                        strokeWidth="5"
                        animationDuration="0.75"
                        width="75"
                        visible={true}
                    />
                </div>
        </>
    )
}

export default LoadingOverlay;